import React, { useEffect, useState } from "react";
import PageHeadline from "../../components/shared/PageHeadline";
import { MinusIcon, PlusIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import API_URL from "../../config/constant";
export default function Faq() {
    const [currentIndex, setCurrentIndex] = useState(null);
    const { t } = useTranslation();

    const [data, setData] = useState(null);
    const locale = useSelector((state) => state.locale.locale);
    useEffect(() => {
        const fetchAboutData = async () => {
            try {
                const response = await fetch(`${API_URL}/faq?lang=${locale}`);
                if (!response.ok) {
                    throw new Error("Data not found");
                }
                const res = await response.json();
                if (res.length < 1) {
                    throw new Error("Data not found");
                }
                setData(res);
            } catch (error) {
                setData(t("faq", { returnObjects: true }));
            }
        };

        fetchAboutData();
    }, [t, locale]);
    return (
        <div className="text-white md:px-0 px-4 relative z-30 bg-main bg-cover bg-no-repeat min-h-screen pb-24">
            <div className="relative max-md:top-32 min-h-[120px] lg:min-h-[300px] bg-bgBannerPage bg-contain md:bg-cover bg-no-repeat top-[86px] md:top-[109px] 2xl:top-[136px] flex justify-center items-center">
                <PageHeadline title={"Frequently Asked Question"} />
            </div>
            <div className="flex max-md:flex-wrap container top-36 md:top-40 relative 2xl:px-0 md:px-14 pb-36 md:pb-48 lg:pb-96 2xl:pb-44 lg:mb-24 w-full mx-auto">
                <div className="basis-full max-md:mb-8 md:min-h-[75vh] container mx-auto px-8 w-full font-poppins text-[#164481] bg-white/60 rounded-3xl">
                    {data?.map((value, index) => (
                        <div
                            key={index}
                            className="py-10 border-b border-brandDarkGreen w-full"
                        >
                            <div className="w-full flex items-center justify-between hover:cursor-pointer" onClick={() =>
                                index === currentIndex
                                    ? setCurrentIndex(null)
                                    : setCurrentIndex(index)
                            }>
                                <h1 className="md:text-2xl text-xl uppercase font-bold text-brandDarkGreen">{value.title}</h1>
                                <button>
                                    {index === currentIndex ? (
                                        <MinusIcon width={24} className="text-brandBlue" />
                                    ) : (
                                            <PlusIcon width={24} className="text-brandBlue" />
                                    )}
                                </button>
                            </div>
                            <div
                                className={`mt-4 w-full ${
                                    index === currentIndex ? "block" : "hidden"
                                }`}
                            >
                                <ul className="space-y-4 w-full">
                                    {value.data.map((data, i) => (
                                        <li className="space-y-2 w-full">
                                            <h2 className="text-md md:text-lg text-gray-600 font-semibold">
                                                {i + 1}. {data.question}
                                            </h2>
                                            <div
                                                dangerouslySetInnerHTML={{ __html: data?.answer }}
                                                className="font-normal text-brandDarkGreen"
                                            />
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
